import type { FC } from 'react'

type Props = {
  children: React.ReactNode
}

const PageContent: FC<Props> = ({ children }) => {
  return (
    <div className="bg-white rounded-lg print:bg-transparent print:mt-0">
      {children}
    </div>
  )
}

export default PageContent
